import bStrg, { parsedToken } from "./storageHelper";
import LoginService from "./login/loginService";
import { handleSessionTimeout } from "./sessionTimeout";
import { request } from "http";

interface callReq {
  url: string;
  method: string;
  body?: {};
  authType?: "bearer" | "authtoken" | "mwAuth" | "pappid";
  appidkey?: string;
  source?: string;
  sourcetoken?: string;
  abortControllerRef?: any;
}
export const apiService = async (
  req: callReq,
  callback: CallableFunction,
  abortController?: CallableFunction
) => {
  const Abort_Controller = new AbortController();
  let pToken: any = parsedToken();
  var params: any = {
    method: req.method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (req.authType) {
    switch (req.authType) {
      case "bearer":
        params.headers.authorization = LoginService.jwtToken
          ? `Bearer ${LoginService.jwtToken}`
          : `Bearer ${bStrg("local").jwt_token}`;
        params.headers.platform = window.localStorage.getItem("isImpersonated")
          ? "rm"
          : window.localStorage.getItem("lgnSrc") === "android-phone"
          ? "android"
          : window.localStorage.getItem("lgnSrc") === "iphone"
          ? "ios"
          : window.localStorage.getItem("lgnSrc") === "X"
          ? "tx3"
          : "WEB";
        break;
      case "authtoken":
        params.headers.authorization =
          LoginService.authorization || (pToken ? pToken.auth_token : "");
        params.headers.Source = "EDEL";
        break;
      case "pappid":
        params.headers["pappid"] = "EX730265";
        break;

      default:
        break;
    }
  }
  if (req.appidkey) {
    params.headers["appidkey"] = req.appidkey;
  }

  if (req.source) {
    params.headers.Source = req.source;
    params.headers.SourceToken = req.sourcetoken;
  }

  if (
    req.method === "POST" ||
    req.method === "PUT" ||
    req.method === "DELETE"
  ) {
    params["body"] = JSON.stringify(req.body);
  }
  //Cancelling Fetch Requests
  if (abortController) {
    abortController(Abort_Controller);
    params.signal = Abort_Controller.signal;
  }
  try {
    const resp = await fetch(req.url, params);
    const newResp = await resp;

    newResp
      .json()
      .then((res) => {
        handleSessionTimeout(newResp, res);
        callback(res, newResp);
      })
      .catch((res) => {
        handleSessionTimeout(newResp, res);
        callback(undefined, newResp);
      });
  } catch (err) {
    // all errors will be captured here for anything in the try block
    callback &&
      callback({
        error: "500",
        errMsg: err,
      });
  }
};

export const apiAService = async (req: callReq) => {
  const Abort_Controller = new AbortController();
  let pToken: any = parsedToken();
  var params: any = {
    method: req.method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (req.authType) {
    switch (req.authType) {
      case "bearer":
        params.headers.Authorization = LoginService.jwtToken
          ? `Bearer ${LoginService.jwtToken}`
          : `Bearer ${bStrg("local").jwt_token}`;
        params.headers.platform = window.localStorage.getItem("isImpersonated")
          ? "rm"
          : window.localStorage.getItem("lgnSrc") === "android-phone"
          ? "android"
          : window.localStorage.getItem("lgnSrc") === "iphone"
          ? "ios"
          : window.localStorage.getItem("lgnSrc") === "X"
          ? "tx3"
          : "WEB";
        break;
      case "authtoken":
        params.headers.authorization =
          LoginService.authorization || (pToken ? pToken.auth_token : "");
        params.headers.Source = "EDEL";
        break;
      case "mwAuth":
        params.headers.mwAuth =
          "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NzEyMjQ4ODEsImV4cCI6MTU4MDMyMjYwMH0.Q-IE3XqL5s8DS7QuN0TWscyzrThMi29Tbfb65wDvamg";
        break;
      case "pappid":
        params.headers.pappid = JSON.parse(
          JSON.stringify(req.body)
        ).applicationid.toString();
        break;
      default:
        break;
    }
  }
  if (req.appidkey) {
    params.headers["appidkey"] = req.appidkey;
  }
  if (req.source) {
    params.headers.Source = req.source;
    params.headers.SourceToken = req.sourcetoken;
  }

  if (
    req.method === "POST" ||
    req.method === "PUT" ||
    req.method === "DELETE"
  ) {
    params["body"] = JSON.stringify(req.body);
  }
  //Cancelling Fetch Requests
  // if (abortController) {
  // 	abortController(Abort_Controller);
  // 	params.signal = Abort_Controller.signal;
  // }
  try {
    const resp = await fetch(req.url, params);
    const newResp = await resp;
    return newResp
      .json()
      .then((res) => {
        handleSessionTimeout(newResp, res);
        return res;
      })
      .catch((error) => {
        handleSessionTimeout(newResp, error);
        return error;
      });
  } catch (err) {
    // all errors will be captured here for anything in the try block
    return {
      error: "500",
      errMsg: err,
    };
  }
};
